// extracted by mini-css-extract-plugin
module.exports = {"select":"legislation_selector-module__select--1Av_5"};